<template>
  <div class="header">
    <div class="container">
      <div class="d-flex align-items-center">
        <RouterLink :to="{ name: 'Home' }">
          <img
            src="https://ot-assets-eu.orangetalent.net/assets/logo/logo-white.svg"
            alt="OrangeTalent logo"
            class="header__logo flex-grow-0 flex-shrink-0"
          />
        </RouterLink>

        <div v-if="isLoggedIn && user" class="header__user d-flex align-items-center ml-auto pl-3">
          <div class="pr-3 text-right">
            <strong class="d-block">{{ user.name }}</strong>

            <button
              type="button"
              class="header__logout"
              @click="onLogOut"
            >
              Uitloggen
            </button>
          </div>

          <Avatar :name="user.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Avatar from './Avatar.vue';

@Component({
  name: 'Header',

  components: {
    Avatar,
  },
})
export default class Header extends Vue {
  get user() {
    return this.$store.getters.user;
  }

  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }

  onLogOut() {
    this.$store.dispatch('logout');
  }
}
</script>

<style type="scss" scoped>
.header {
  color: #fff;
  padding: 1rem 0;
}

.header__logo {
  width: 13.125rem;
  height: auto;
}

.header__user {
  font-size: .9375rem;
}

.header__logout {
  color: #2a1559;
  border: 0;
  padding: 0;
  background: none;
  text-decoration: underline;
}

@media (min-width: 992px) {
  .header {
    padding: 1.25rem 0;
  }
}
</style>
